import { useEffect } from "react";

import { toast } from "@jasperlabs/ui";

import { useSession } from "@/contexts/session";
import { useRedirectToLogin } from "@/components/utilities/authentication/useRedirectToLogin";

const ExpiredSession = () => {
	const { hasAuthenticatedSession, hasSessionExpired } = useSession();
	const redirectToLogin = useRedirectToLogin();

	useEffect(() => {
		const hasExpiredSession = hasAuthenticatedSession && hasSessionExpired;
		if (hasExpiredSession) {
			toast.warning(
				"Your session has expired. Please login again to continue.",
			);
			redirectToLogin();
		}
	}, [hasAuthenticatedSession, hasSessionExpired, redirectToLogin]);

	return null;
};

export default ExpiredSession;
